import React from "react";
import { connect } from "react-redux";

import { isLoadingAvailableProducts } from "state/app/selectors";

import Gate from "components/Gate";
import LoadingPage from "components/LoadingPage";

class Preloader extends React.Component {
  
  placeholder = <LoadingPage />
  
  render() {
    const { isLoadingAvailableProducts, children } = this.props;
    return (
      <Gate isOpen={!isLoadingAvailableProducts} placeholder={this.placeholder}>
        { children }
      </Gate>
    )
  }
  
}

export default connect(
  state => ({
    isLoadingAvailableProducts: isLoadingAvailableProducts(state)
  })
)(Preloader);



// WEBPACK FOOTER //
// ./src/components/app/Preloader.js